<template>
<div>
    <smallbutton :toplabel="title" @click="Show()" v-if="showButton" :disabled="disabled" :buttonclass="buttonclass"/>
    <linkbutton :toplabel="title" @click="Show()" v-if="showLink" :disabled="disabled"/>

    <!-- MODAL -->
      <actionmodalwide ref="mymodal"> 
        <template v-slot:body>
            <label class="titlelabel">{{title}}</label>
           <br>
           <br>
            <div class="splitdiv">
                <!-- to return -->
                <div class="vertFlex">
                    <label class="titlelabel">1. Lookup product to Return</label>
                    <div class="product-lookup">
                        <input ref="lookupproduct1" type="search"  :placeholder="productlookuptext" class="textbox" v-model="productString_toReturn" @keyup.enter="lookupProduct_toReturn()" @input="searchchange_toReturn"/>
                        <button class="btn-small actionbutton" @click="lookupProduct_toReturn">Lookup</button>
                        
                    </div>
                    <!-- products from scan -->
                    <div class="lineitemavailable_exchange" v-if="scannedItems_toReturn.length!=0">
                        <availableitem
                            v-for="cartItem in scannedItems_toReturn"
                            v-bind:key="cartItem.id"
                            v-bind:cartItem="cartItem" @additem="addScannedItem_toReturn"
                        />
                    </div>
                    
                    
                    <CartItem :showButtons="paramFalse" v-for="cartItem in cartItems_toReturn" v-bind:key="cartItem.id" v-bind:cartItem="cartItem"  @removeitem="removelineitem" @refresh="refresh"  @updatequantity="updateitemquantity" @returnitem="returnitem"/>

                </div>
                
                <!-- to purchase -->
                <div>
                    <label class="titlelabel">2. Lookup product to Purchase</label>
                    <div class="product-lookup">
                        <input ref="lookupproduct" type="search"  :placeholder="productlookuptext" class="textbox" v-model="productString_toPurchase" @keyup.enter="lookupProduct_toPurchase()" @input="searchchange_toPurchase"/>
                        <button class="btn-small actionbutton" @click="lookupProduct_toPurchase">Lookup</button>
                        
                    </div>
                    
                    <!-- products from scan -->
                    <div class="lineitemavailable_exchange" v-if="scannedItems_toPurchase.length!=0">
                        <availableitem
                            v-for="cartItem in scannedItems_toPurchase"
                            v-bind:key="cartItem.id"
                            v-bind:cartItem="cartItem" @additem="addScannedItem_toPurchase"
                        />
                    </div>
                    <CartItem :showButtons="paramFalse" v-for="cartItem in cartItems_toPurchase" v-bind:key="cartItem.id" v-bind:cartItem="cartItem"  @removeitem="removelineitem" @refresh="refresh"  @updatequantity="updateitemquantity" @returnitem="returnitem"/>

                </div>
            </div>
            
            <label class="responsemessage" v-if="showMatchMessage">Please select products of equal price.</label>

            <div class="horizFlexCenter">
                
               <confirm  v-if="AskInventoryForReturn" :showButton="paramTrue"  body="Do you want to return this item to stock?" title="Exchange" @yes="YesReturn()" @no="NoReturn()" :disabled="!pricesMatch" buttonclass="button buttonprimary"/>   
               
                <smallbutton v-if="!AskInventoryForReturn" @click="YesReturn" toplabel="Exchange" :disabled="!pricesMatch"/> 
                <smallbutton  @click="CloseWithNo" toplabel="Cancel"/>
               
               
           
            </div>
            
            <div>
              <label class="responsemessage">{{responseMessage}}</label>
            </div>
        </template>
      </actionmodalwide>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import smallbutton from '../controls/button.vue'
import actionmodalwide from '../controls/actionmodalwide.vue'
import linkbutton from '../controls/linkbutton.vue'
import pos from '../../services/pos.js'
import CartItem from "../actions/CartItem.vue";
import availableitem from '../actions/availableitem.vue'
 import confirm from '../actions/confirm.vue'
export default {
    name:'exchange',
    components:{
        smallbutton,
        actionmodalwide,
        linkbutton,
        availableitem,
        CartItem,
        confirm
        
    },
    mixins:[pos],
    props:{
        title:{
            type:String,
            required:true
        },
        body:{
            type:String,
        },
        showButton:{
            type:Boolean,
            default:false
        },

        showLink:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        buttonclass:{
            type:String,
            default:"button primarybutton"
        },
        isAlert:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            responseMessage:'',
            paramFalse:false,
            paramTrue:true
        }
    },
    computed:{
        showMatchMessage(){
            return !this.pricesMatch && this.cartItems_toPurchase.length>0 && this.cartItems_toReturn.length>0
        },
        textclass(){
            if(this.isAlert){return 'required'}
            else{return ''}
        },
        ...mapFields([
                'responseMessage',
                'pleaseWait',
                'productlookuptext'
        ]),
        pricesMatch(){
            var p1 =0
            if(this.cartItems_toReturn.length>0){
               p1= this.cartItems_toReturn[0].unitPrice
            } 

             var p2 =0
            if(this.cartItems_toPurchase.length>0){
               p2= this.cartItems_toPurchase[0].unitPrice
            } 
            return p1>0 && p1==p2
        },
    },
    methods:{
        
        Show(){
            this.responseMessage=null
            this.scannedItems_toPurchase=[]
            this.scannedItems_toReturn=[]
            this.productString_toReturn=''
            this.productString_toPurchase=''
            this.cartItems_toReturn=[]
            this.cartItems_toPurchase=[]
            
            this.$refs.mymodal.openModal()
            this.$nextTick(()=>{
                this.$refs.lookupproduct1.focus()
            });
        },
        async YesReturn(){
            this.isExchange=true
            this.saveExchangeItems(true)
            this.$refs.mymodal.closeModal()
        },
        async NoReturn(reason){
            this.isExchange=true
            this.saveExchangeItems(false,reason)
            this.$refs.mymodal.closeModal()
        },
        async CloseWithNo(){
       
            this.$refs.mymodal.closeModal()
        },
        searchchange_toReturn(event){
            if(event.target.value.trim().length===0){
                this.scannedItems_toReturn=[]
            }
        },
        searchchange_toPurchase(event){
            if(event.target.value.trim().length===0){
                this.scannedItems_toPurchase=[]
            }
        },
    }
}
</script>

<style>
.lineitemavailable_exchange {
  /* grid-area: itemavailable; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
}
</style>